<!--  -->
<template>
  <div>
    <div class="titbox">
      <img src="/static/images_m/icon1.png">
      <p>我的课程</p><img src="/static/images_m/go.png">
    </div>
    <ul class="ul_1">
      <li v-for="(course,index) in courses" :key="index"  @click="$router.push(`/courview/info/${course._id}`)">
          <img :src="`${global.remoteIp}/uploads/${course.picsrc}`"  style="height:91.76px">
          <div class="tit">{{course.title}}</div>
          <div class="price">{{course.author}}<span>{{course.isBuy==1? '立即学习':course.isBuy==0?'报名学习':course.isBuy==3?'未开始':'已到期'}}</span></div>
      </li>
    </ul>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      catesel: "",
      courses: [],
      global,
    };
  },

  components: {},

  computed: {},

  mounted() {

    this.$axios
      .get("/api/courses/visitor?page=1&limit=2&sort=-createdAt&type[in]="+ this.$root.hasCourse)
      .then((res) => {
        if (res.data) {
          this.courses = res.data.data;
        }
      });
  },

};
</script>
<style  lang="scss" scoped>
  @import "@/assets/css/style_Phone.scss";
</style>
